'use client';

import { FC } from 'react';
import { SortOption } from '@/components/Product/SortBy/constants';
import { ISortOption } from '@/components/Product/SortBy/types';
import {
  Flex,
  Text,
  Drawer,
  DrawerBody,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  DrawerProps,
  useDisclosure,
  Box,
} from '@chakra-ui/react';
import colors from '@/constants/theme/colors';
import SortOptions from '@/components/Product/SortBy/SortOptions';

type MobileSortByProps = {
  sortBy?: ISortOption;
  onSortByChange?: (val: ISortOption) => void;
};
const MobileSortBy: FC<MobileSortByProps> = ({
  sortBy = SortOption.priceDesc,
  onSortByChange,
}) => {
  const { isOpen, onClose, onOpen } = useDisclosure();

  return (
    <>
      <SortByDrawer
        isOpen={isOpen}
        onClose={onClose}
        sortBy={sortBy}
        onSortByChange={onSortByChange}
      />
      <Flex
        borderRadius="6.25rem"
        border={`1px solid ${colors.primary[50]}`}
        p="0.625rem 1rem"
        justifyContent="center"
        userSelect="none"
        onClick={onOpen}
        display={{ base: 'flex', lg: 'none' }}
      >
        <Text
          textAlign="center"
          color="primary.200"
          fontSize="0.875rem"
          lineHeight="1.25rem"
        >
          Sort by
        </Text>
      </Flex>
    </>
  );
};

type SortByDrawerProps = Omit<DrawerProps, 'children'> & {
  sortBy?: ISortOption;
  onSortByChange?: (val: ISortOption) => void;
};
const SortByDrawer: FC<SortByDrawerProps> = ({
  sortBy = SortOption.priceDesc,
  onSortByChange,
  ...drawerProps
}) => {
  const { onClose } = drawerProps;

  return (
    <Drawer placement="bottom" variant="mobileBottomMenu" {...drawerProps}>
      <DrawerOverlay />
      <DrawerContent>
        <DrawerCloseButton />
        <DrawerHeader>
          <Text>Sort by</Text>
        </DrawerHeader>

        <DrawerBody>
          <Box p="1rem 0 0.5rem" onClick={onClose}>
            <SortOptions value={sortBy} onChange={onSortByChange} />
          </Box>
        </DrawerBody>

        <DrawerFooter></DrawerFooter>
      </DrawerContent>
    </Drawer>
  );
};

export default MobileSortBy;
